export default function useCopyToClipboard() {
  const wasClicked = ref(false)

  function copyToClipboard({ copyText }) {
    if (!process.client) return

    try {
      navigator.clipboard.writeText(copyText)
    } finally {
      wasClicked.value = true

      setTimeout(function () {
        wasClicked.value = false
      }, 2000)
    }
  }

  return { wasClicked, copyToClipboard }
}
